module.exports = __webpack_public_path__ + "media/images/design/images/bn_teiju-0eba7a94b496c8a0384680e9d38d3f4a.jpg";